import {
  InjectedExperimentsProps,
  withExperiments,
} from '@wix/wix-experiments-react';
import classNames from 'classnames';
import { AnimatePresence, motion } from 'framer-motion';
import { RootStore, withInjectedRootStore } from 'providers';
import { usePageModeContext } from 'providers/PageMode/PageMode.provider';
import * as React from 'react';
import { Heading } from '@wix/design-system';
import s from './AppTitle.scss';
import { useDelayedMount } from './useDelayedMount';

interface TitleProps extends InjectedExperimentsProps {
  titleText: string;
  rootStore: RootStore;
}

const variants = {
  initial: {
    opacity: 0,
    y: 48,
  },
  exit: () => ({
    opacity: 0,
    transition: {
      type: 'tween',
      duration: 0.42,
      ease: [0.075, 0.82, 0.165, 1],
    },
  }),
  visible: (i) => ({
    opacity: 1,
    y: 0,
    transition: {
      type: 'tween',
      delay: i * 0.05,
      duration: 0.42,
      ease: [0.075, 0.82, 0.165, 1],
    },
  }),
};

const TitleComp: React.FC<TitleProps> = ({ titleText, experiments }) => {
  const [words, setWords] = React.useState<string[]>([]);
  const [isMounted] = useDelayedMount({
    delay: 240,
    onChange: titleText,
    onMounted: () => setWords(titleText.split(' ')),
  });
  const { theme } = usePageModeContext();

  return (
    <Heading className={classNames(s.advancedPlansHeading)}>
      {isMounted && (
        <div
          data-hook='page-title'
          className={classNames(s.headingContent, theme)}
        >
          <AnimatePresence exitBeforeEnter>
            <>
              {words.map((word, i) => (
                <motion.div key={i}>
                  <motion.span
                    custom={i}
                    variants={variants}
                    initial='initial'
                    animate='visible'
                    exit='exit'
                  >
                    {word}
                  </motion.span>
                </motion.div>
              ))}
            </>
          </AnimatePresence>
        </div>
      )}
    </Heading>
  );
};

export const Title = withInjectedRootStore(withExperiments(TitleComp));
